// WARNING: "Invite Status" column filter values on the Invitation Status Grid are displayed when enum
// keys are matching API response, modifying enum keys can lead to values being displayed incorrectly.
export enum InvitationStatus {
  INVITATION_REQUESTED = 1,
  INVITATION_STILL_IN_PROCESS = 2,
  TOO_MANY_ATTEMPT = 3,
  INVALID_URL = 4,
  PENDING = 5,
  EXPIRED = 6,
  STARTED = 7,
  PASSWORD_SET = 8,
  USER_CONFIGURED = 9,
  CLINIC_CONFIGURED = 10,
  CLIENT_CONFIGURED = 11,
  COMPLETED = 12,
  VALIDATE_PIN = 13,
  LINK_ALREADY_USED = 14,
  INVITATION_IN_USE = 15
}

const InvitationStatusMap = new Map<InvitationStatus, string>([
  [InvitationStatus.INVITATION_REQUESTED, "Invitation Requested"],
  [InvitationStatus.INVITATION_STILL_IN_PROCESS, "Invitation Still In Process"],
  [InvitationStatus.TOO_MANY_ATTEMPT, "Too Many Attempts"],
  [InvitationStatus.INVALID_URL, "Invalid URL"],
  [InvitationStatus.PENDING, "Pending"],
  [InvitationStatus.EXPIRED, "Expired"],
  [InvitationStatus.STARTED, "Started"],
  [InvitationStatus.PASSWORD_SET, "Password Set"],
  [InvitationStatus.USER_CONFIGURED, "User Configured"],
  [InvitationStatus.CLINIC_CONFIGURED, "Portal Configured"],
  [InvitationStatus.CLIENT_CONFIGURED, "Company Configured"],
  [InvitationStatus.COMPLETED, "Complete"]
])

const InvitationInverseMap = new Map<string, InvitationStatus>(Array.from(InvitationStatusMap, entry => [entry[1], entry[0]]))

export function getStatusLabelByKey(key: InvitationStatus) {
  return InvitationStatusMap.get(key) || ""
}

export function getStatusKeyByLabel(label: string) {
  const stringKey = InvitationInverseMap.get(label)
  if (stringKey) {
    return InvitationStatus[stringKey]
  }
}
